import React from "react";
import { Instagram, Twitter, Music2, ArrowUpRight } from "lucide-react";

const socials = [
  {
    name: "Instagram", handle: "@halos_in_the_infield",
    url: "https://www.instagram.com/halos_in_the_infield/",
    icon: Instagram, key: "ig",
    description: "Behind-the-scenes shots, episode promos, & game-day pics.",
  },
  {
    name: "Twitter / X", handle: "@HalosInfield",
    url: "https://x.com/HalosInfield",
    icon: Twitter, key: "tw",
    description: "Hot takes, live reactions, & in-game commentary.",
  },
  {
    name: "TikTok", handle: "@halos_in_the_infield",
    url: "https://www.tiktok.com/@halos_in_the_infield",
    icon: Music2, key: "tt",
    description: "Bite-size clips, hot mic moments, & viral baseball content.",
  },
];

export default function SocialFeed() {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-16" data-testid="social-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="text-halo-red font-sports uppercase tracking-[0.3em] text-xs mb-3">The Feed</div>
            <h2 className="font-sports uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-halo-navy">
              Follow <span className="text-halo-red">Everywhere</span>
            </h2>
          </div>
          <p className="font-body text-halo-navy/60 max-w-sm text-sm">
            Catch the conversation in real time across every platform.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {socials.map((s) => {
            const Icon = s.icon;
            return (
              <a
                key={s.key}
                href={s.url} target="_blank" rel="noreferrer"
                data-testid={`social-${s.key}-card`}
                className="group block bg-white border-2 border-halo-navy p-7 hover:bg-halo-navy hover:text-halo-cream transition-colors"
              >
                <div className="flex items-start justify-between">
                  <Icon className="w-10 h-10" strokeWidth={2} />
                  <ArrowUpRight className="w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity" strokeWidth={2.5} />
                </div>
                <h3 className="font-sports uppercase tracking-tight text-3xl mt-6">{s.name}</h3>
                <div className="font-body text-sm mt-1 opacity-70">{s.handle}</div>
                <p className="font-body text-sm mt-4 leading-relaxed opacity-80">{s.description}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
